import momentTZ from 'moment-timezone';

import SelectInput from './SelectInput';
import type { SelectInputProps } from './SelectInput';

/**
 * Селект часового пояса (зоны РФ).
 *
 * Внимание: в JSX `value` идёт ДО `{...props}` — value потребителя
 * перекрывает автоподобранную локальную зону.
 */
export interface TimezoneSelectProps extends SelectInputProps {
  /** Подставить локальную зону браузера как начальное value. @default true */
  autoSelectLocalTimezone?: boolean;
}

const TimezoneSelect = (props: TimezoneSelectProps) => {
  const {
    isClearable = false,
    autoSelectLocalTimezone = true,
  } = props;

  return (
    <SelectInput
      data={ momentTZ.tz.zonesForCountry('RU').map(v => ({ id: v, name: v })) }
      dataTitle='name'
      dataValue='id'
      value={ autoSelectLocalTimezone ? Intl.DateTimeFormat().resolvedOptions().timeZone : undefined }
      { ...(props as any) } /* ref react-select (LegacyRef<Select>) инвариантен ref'у SelectInput
                                    (LegacyRef<HTMLElement>) — типы конфликтуют, runtime 1:1 */
      isClearable={ isClearable }
    />
  );
};

export default TimezoneSelect;
